import React, { createContext, useContext } from 'react';

export const NOTIFICATION_TYPES = {
  COMMENT: 'comment',
  REPLY: 'reply',
  REPORT_RESULT: 'report_result',
  APPROVAL: 'approval',
  MENTION: 'mention',
  SYSTEM: 'system'
};

const NotificationContext = createContext(null);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    // Return safe defaults instead of throwing
    return {
      notifications: [],
      unreadCount: 0,
      markAsRead: () => {},
      markAllAsRead: () => {},
      deleteNotification: () => {},
    };
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const value = {
    notifications: [],
    unreadCount: 0,
    fetchNotifications: () => {},
    markAsRead: () => {},
    markAllAsRead: () => {},
    deleteNotification: () => {},
  };
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
